let user = {
  	state: {
        sendOrderInfo: {
            newEquipments: []
        }
  	},
  	mutations: {
      Logout (state) {
				state = {}
				sessionStorage.removeItem('user')
      },
      Login (state, data) {
				for(let key in data){
					state[key] = data[key]
				}
				sessionStorage.setItem('user',JSON.stringify(state))
      }
    }
}
let data = sessionStorage.getItem('user')?JSON.parse(sessionStorage.getItem('user')):{}
for(let key in data){
	user.state[key] = data[key]
}

export default user


// WEBPACK FOOTER //
// ./src/store/user/index.js